import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class Tabs extends PureComponent {
    constructor(props) {
        super(props);

        this.renderTabButton = this.renderTabButton.bind(this);
        this.renderTab = this.renderTab.bind(this);
    }

    renderTabButton(node, i) {
        const { disabled, title, buttonClassName } = node.props;
        return (
            <button
                className={classNames(
                    'ui-btn',
                    buttonClassName,
                    i === this.props.activeTabIndex ? 'ui-btn_primary' : 'ui-btn_secondary'
                )}
                disabled={disabled}
                onClick={() => this.props.onTabChange(i)}
            >
                {title}
            </button>
        );
    }

    renderTab(node, i) {
        return (
            <div
                className={classNames(
                    'sales__catalogueRefineOptionsWrp',
                    { hidden: i !== this.props.activeTabIndex }
                )}
            >
                {node}
            </div>
        );
    }

    render() {
        const { children, switcherAdditionalChildren, contentAdditionalChildren } = this.props;
        return (
            <div className="sales__catalogueRefineTabs">
                <div className="sales__catalogueRefineTabsNav">
                    {React.Children.map(children, this.renderTabButton)}
                    {switcherAdditionalChildren}
                </div>
                <div className="sales__catalogueRefineTabsContent">
                    {React.Children.map(children, this.renderTab)}
                    {contentAdditionalChildren}
                </div>
            </div>
        );
    }
}

Tabs.propTypes = {
    children: PropTypes.arrayOf(PropTypes.node),
    switcherAdditionalChildren: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.arrayOf(PropTypes.node)
    ]),
    contentAdditionalChildren: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.arrayOf(PropTypes.node)
    ]),
    activeTabIndex: PropTypes.number.isRequired,
    onTabChange: PropTypes.func.isRequired,
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/js/components/Catalogue/Tabs.js